import { Link } from "react-router-dom";
import { routes } from "../lib/routes";
import { BlobDecoration } from "../components/BlobDecoration";
import { PageHead } from "../components/PageHead";
import { Button } from "../components/ui/button";
import { Icon } from "../components/ui/icons/icon";
import nomaIcon from "../assets/noma-icon.svg";

export default function NotFound() {
  return (
    <>
      <PageHead title="Page not found" description="This page doesn't exist." />
      <div className="min-h-full bg-background overflow-hidden relative flex flex-col">
        <div className="hidden md:block">
          <BlobDecoration
            className="absolute -top-20 right-0 w-80 h-80 opacity-25 translate-x-1/3 text-chart-1"
            variant={1}
          />
          <BlobDecoration className="absolute top-40 right-0 w-48 h-48 opacity-15 text-chart-2" variant={2} />
          <BlobDecoration className="absolute -bottom-32 -left-40 w-80 h-80 opacity-30 text-chart-5" variant={3} />
          <BlobDecoration className="absolute bottom-20 -left-20 w-40 h-40 opacity-25 text-[#f9b4ab]" variant={4} />
        </div>
        <div className="md:hidden">
          <BlobDecoration className="absolute -top-10 -right-10 w-48 h-48 opacity-20 text-chart-1" variant={1} />
          <BlobDecoration className="absolute top-1/4 -right-20 w-32 h-32 opacity-15 text-chart-2" variant={2} />
          <BlobDecoration className="absolute bottom-32 -left-16 w-56 h-56 opacity-30 text-[#f9b4ab]" variant={3} />
        </div>

        <header className="relative px-6 md:px-8 py-6 flex justify-between items-center max-w-7xl mx-auto w-full">
          <Link to={routes.to.home()} className="hover:opacity-80 transition-opacity">
            <img src={nomaIcon} alt="noma.to" className="h-18 border-3 border-secondary rounded-sm" />
          </Link>
        </header>

        <main className="flex-1 flex items-center justify-center px-6 md:px-8 relative">
          <div className="text-center max-w-md">
            <div className="mb-8 inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary">
              <Icon i="compass" className="w-10 h-10 text-primary-foreground" aria-hidden="true" />
            </div>

            <h1 className="text-3xl md:text-4xl font-light text-foreground mb-4 tracking-tight">Off the map</h1>
            <p className="text-muted-foreground text-base md:text-lg mb-10 leading-relaxed">
              This path leads nowhere. Let&apos;s get you back on track.
            </p>

            <Button asChild variant="outline" className="rounded-full px-6">
              <Link to={routes.to.home()}>
                Take me home
                <Icon i="arrow-right" className="w-4 h-4" aria-hidden="true" />
              </Link>
            </Button>
          </div>
        </main>

        <footer className="relative py-12 md:py-20 px-6 md:px-8">
          <div className="hidden md:block">
            <BlobDecoration className="absolute -bottom-16 -right-16 w-72 h-72 opacity-20 text-accent" variant={4} />
          </div>
          <div className="max-w-4xl mx-auto text-center relative">
            <p className="text-sm text-muted-foreground">
              Create your own adventure map at{" "}
              <Link to={routes.to.home()} className="hover:text-primary transition-colors">
                noma.to
              </Link>
            </p>
          </div>
        </footer>
      </div>
    </>
  );
}
